export default __webpack_public_path__ + "static/media/arrow-right.7e01f9a0.svg";